import { render, staticRenderFns } from "./BonusQuickstartCardsItemLeg.vue?vue&type=template&id=56a6c19e&scoped=true"
import script from "./BonusQuickstartCardsItemLeg.vue?vue&type=script&lang=js"
export * from "./BonusQuickstartCardsItemLeg.vue?vue&type=script&lang=js"
import style0 from "./BonusQuickstartCardsItemLeg.vue?vue&type=style&index=0&id=56a6c19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a6c19e",
  null
  
)

export default component.exports